<!--  -->
<template>
  <div class="container">
    <van-collapse v-model="activeNames" style="margin-top:20px">
      <van-collapse-item class="collapse" :title="item.name" style="margin-top:10px" :name="index" icon="stop" v-for="(item,index) in imgList" :key="index">
        <div class="item" style="marginRight:4%">
          <div class="content" @click="getImg(index)">
            <img :src="item.url" alt />
          </div>
          <div class="show_text">样例展示</div>
        </div>
        <van-uploader
          class="item "
          :class="lookImgList.length == 0?'item_one':''"
          :after-read="afterRead"
          v-model="fileList[index]"
          multiple
          :name="index"
          :max-count="1"
        >
          <div class="content">
            <img :src="lookImgList.length == 0?defaultImg:lookImgList[index].url" alt />
          </div>
          <div class="show_text">请选择图片</div>
        </van-uploader>
      </van-collapse-item>
    </van-collapse>
    <div class="btn">
      <button class="uploading" @click="submitAudit">提交审核</button>
    </div>
    
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import { ImagePreview } from "vant";
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    //这里存放数据
    return {
      activeNames: ["0"],
      fileList: [],
      planId:null,//班期id
      workType:"",//工种
      courseId:null,//课程Id
      arr:[],
      imgList:[],
      lookImgList:[],
      data:{},
      submitInfo:[],//所提交的资料
      from:null,
      defaultImg:require('../../assets/image/camera@2x.png')
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    //提交上传
    submitAudit() {
      this.data.plan_id = this.planId;
      this.data.work_type = this.workType;
      if(this.fileList.length != this.imgList.length){
        this.$hide.alert({
            message:"请上传图片"
          })
      }else{
        for (let index = 0; index < this.imgList.length; index++) {
         this.data['filetype_'+this.imgList[index].id] = this.fileList[index].url
      }
      this.$toast.loading({message:""})
       this.$http.studentSign(this.data).then(res=>{
        this.$toast.clear()
        if(res.status == 1){
          this.$hide.alert({
            message:res.msg
          }).then(()=>{
            this.$router.push({name:'submitSuccess',params:{from:1}})
          })
        }else{
          this.$hide.alert({
            message:res.msg
          })
        }
      })
      }
    },
    // 选择文件+上传文件
    afterRead(file,index) {
      // 此时可以自行将文件上传至服务器
      let number = index.name
      // let fileContent = file.content.replace(/^data:image\/\w+;base64,/, '')
      this.getItemFun(file.content,number)
      
    },

    getItemFun(originalImg,number){
      let that = this
      let base64Arr = originalImg.split(",");
      let imgtype = "";
      let base64String = "";
      if (base64Arr.length > 1) {
        //如果是图片base64，去掉头信息
        base64String = base64Arr[1];
        imgtype = base64Arr[0].substring(
          base64Arr[0].indexOf(":") + 1,
          base64Arr[0].indexOf(";")
        );
      }
      // 将base64解码
      let bytes = atob(base64String);
      //let bytes = base64;
      let bytesCode = new ArrayBuffer(bytes.length);
      // 转换为类型化数组
      let byteArray = new Uint8Array(bytesCode);
      // 将base64转换为ascii码
      for (let i = 0; i < bytes.length; i++) {
        byteArray[i] = bytes.charCodeAt(i);
      }
      // 生成Blob对象（文件对象）
      let bolbObj = new Blob([bytesCode], { type: imgtype });
      let reader = new FileReader(); // 这个方法读取文件的bolb对象
      //将图片转成base64格式
      reader.readAsDataURL(bolbObj);
      reader.onloadend = function() {
        let result = this.result;
        let img = new Image();
        img.src = result;
        img.onload = function() {
          let data = that.compress(img, 0.1);
          that.uploadImg(data,number);
        };
      };
    },

    // 点击预览图片
    getImg(index) {
      let arr = []
      for (let i = 0; i < this.imgList.length; i++) {
        arr.push(this.imgList[i].url)
      }
      ImagePreview({
        images: arr,
        showIndex: true,
        loop: false,
        closeOnPopstate: true,
        cover: "哈哈哈哈哈",
        index: index,
        startPosition: index,
      });
    },

    compress(img,size){
      // 创建canvas
        let canvas = document.createElement('canvas')
        let ctx = canvas.getContext('2d')
        // let initSize = img.src.length
        let width = img.width
        let height = img.height
        canvas.width = width
        canvas.height = height
        // 铺底色
        ctx.fillStyle = '#fff'
        ctx.fillRect(0, 0, canvas.width, canvas.height)
        ctx.drawImage(img, 0, 0, width, height)
        //进行最小压缩
        let ndata = canvas.toDataURL('image/jpeg', size)
        return ndata
    },
    uploadImg(base64,number){
      this.$http.uploadPic({
          image: base64
        }).then(res => {
            if(res.status == 1){
                this.fileList[number].url = res.data.path
            }
        });
    },
    // 获取报名资料信息
    getInfo() {
      let id = this.courseId;
      this.$toast.loading({ message: "加载中" });
      this.$http.getSignDataList({ course_id: id }).then(res => {
        this.$toast.clear();
        if (res.status == 1) {
          let obj = {}
          let list = res.data
          list.map((current) => {
            current.url = "https://www.jspx0769.com" + current.url;
            obj['filetype_'+current.id]	= ''
            // obj.
          });
          this.imgList = list;
          this.data = obj//接口参数
        }
      });
    },
    // 获取学员报名某一班期所提交的资料
    lookInfo(id){
      this.$toast.loading({ message: "加载中" });
      this.$http.getStudentSignDetail({
        sign_id:id
      }).then(res=>{
        this.$toast.clear();
        if(res.status == 1){
          let data = res.data
          data.map(current =>{
            current.url = "https://www.jspx0769.com" + current.url;
          })
          this.lookImgList = data
        }
      })
    }
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
      let plan_id = this.$route.query.id
      let course_id = parseInt(this.$route.query.course_id) 
      let work_type = this.$route.query.work_type
      this.planId = plan_id
      this.courseId = course_id
      this.workType = work_type
      this.getInfo()
    if(this.$route.query.from == 1){
      // let id = this.$route.query.id
      // this.from = this.$route.query.from
      // this.lookInfo(id)
    }


    // 处理取消报名之后再次报名的时候图片信息要显示出来
    let cancelId = JSON.parse(localStorage.getItem("courseId"))
    if(cancelId){
      for (let index = 0; index < cancelId.length; index++) {
        if(course_id == cancelId[index].courseId){
          this.lookInfo(cancelId[index].id)
        }
      }
    }
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {} //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang='less' scoped>
//@import url(); 引入公共css类
.container {
  width: 100%;
  // overflow: hidden;
  background-color: #f5f5f5;
  padding: 0 18px;
  box-sizing: border-box;
  .btn{
    width: 100%;
    text-align: center;
    margin-top: 50px;
    .uploading {
    width: 90%;
    height: 44px;
    background-color: #0e88f7;
    color: #fff;
    border-radius: 22px;
    border: none;
    font-size: 17px;
  }
  }
  
  .item {
    width: 48%;
    display: inline-block;
    vertical-align: middle;
    height: 140px;
    box-sizing: border-box;
    .content {
      width: 100%;
      height: 140px;
      display: inline-block;
      text-align: center;
      border: 1px solid #dddddd;
      // overflow: hidden;
      line-height: 140px;
      img {
        width: 80%;
        height: 98px;
        vertical-align: middle;
      }
    }
    .show_text {
      width: 100%;
      text-align: center;
      margin-top: 5px;
    }
  }
  .item_one {
    // margin-left: 4%;
    .content {
      img {
        width: 50px;
        height: 50px;
      }
    }
  }
}
</style>
<style >
body{
  background-color: #f5f5f5;
}
.van-uploader__input-wrapper {
  width: 100%;
}
van-uploader {
  width: 48%;
  display: inline-block;
}
.van-uploader__wrapper,
.van-uploader__preview {
  width: 100%;
  height: 100%;
  text-align: center;
}
.van-uploader__wrapper {
  border: 1px solid #dddddd !important;
}
.van-uploader__preview-image {
  width: 80% !important;
  height: 98px !important;
  vertical-align: middle !important;
  margin: 20px auto 0 !important;
}
.van-collapse-item__content {
  padding-bottom: 30px !important;
}
.van-cell{
  padding: 14px 16px !important;
}
.van-icon-stop:before{
  color: #0e88f7 !important;
}
</style>